<template>
    <div class="form-group" style="margin-top: 20px">
        <label>
            <span v-html="fieldConfig.label"></span>
            <span class="required" v-if="fieldConfig.field_extra.required">&nbsp;&nbsp;(*)</span>
            <span v-if="withHelpIcon" :class="fieldConfig.field_extra.withIcon" :title="fieldConfig.field_extra.helpText"></span>
        </label>
        <div v-if="hasHelpText" class="help-text">
            <span v-html="fieldConfig.field_extra.helpText" ref="modalRef"></span>
        </div>
        <div class="radio" v-for="option in fieldConfig.field_extra.options_config.options" :key="option[fieldConfig.field_extra.options_config.optionValueField]">
            <label>
                <input type="radio"
                       :name="fieldConfig.fieldName"
                       :id="fieldConfig.fieldName + '-' + option[fieldConfig.field_extra.options_config.optionValueField]"
                       :value="option[fieldConfig.field_extra.options_config.optionValueField]"
                       @click="updateValue(option[fieldConfig.field_extra.options_config.optionValueField])"
                       :checked="value === option[fieldConfig.field_extra.options_config.optionValueField]"
                       :disabled="fieldConfig.disabled === 1"
                >
                {{ option[fieldConfig.field_extra.options_config.optionLabelField] }}
            </label>
        </div>
        <modal
            v-if="showModal"
            @close="showModal = false"
            confirm-no-text="Close"
            class="modal"
        >
            <span slot="header" v-html="fieldConfig.label"></span>
            <div slot="body">
                <span v-html="fieldConfig.field_extra.modalText"></span>
            </div>
        </modal>
    </div>
</template>
<script>
    import { FormFieldMixin } from 'laravel-vue-forms';
    export default {
        name: 'form-radio-with-modal',
        mixins: [FormFieldMixin],
        methods: {
            updateValue(optionValue) {
                this.$emit('input', optionValue);
            },
        },
        data() {
            return {
                showModal: false,
            }
        },
        mounted() {
            this.$nextTick(() => {
                let self = this;

                // only change the showModal value if the first child element attribute is form-radio-modal
                if(
                    this.$refs['modalRef'].hasChildNodes() &&
                    this.$refs['modalRef'].querySelector('[data-modal="form-radio-modal"]')
                ) {
                    this.$refs['modalRef'].querySelector('[data-modal="form-radio-modal"]').addEventListener('click', e => {
                        e.preventDefault();
                        self.showModal = true;
                    });
                }
            });
        }
    }
</script>
